// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Coach dashboard — dark theme aligned with .lt-kot__table-card */
.lt-coach-dash {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  width: 100%;
  gap: 8px;
  padding: 4px 0 8px;
  color: #f8fafc;
  overflow: hidden;
}

.lt-coach-dash__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  background: rgba(15, 23, 42, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  flex-shrink: 0;
  flex-wrap: wrap;
  position: sticky;
  top: 0;
  z-index: 20;
  backdrop-filter: blur(8px);
}

.lt-coach-dash__toolbar-actions {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.lt-coach-dash__action-group {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px;
  border-radius: 10px;
  background: color-mix(
    in srgb,
    var(--lt-brand-secondary, #46528b) 14%,
    rgba(15, 23, 42, 0.5)
  );
  border: 1px solid
    color-mix(in srgb, var(--lt-brand, #0877bc) 24%, rgba(255, 255, 255, 0.08));
}

.light-mode .lt-coach-dash__action-group,
html[data-theme="light"] .lt-coach-dash__action-group {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 6%, #f8fafc);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);
}

.lt-coach-dash__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.lt-coach-dash__stat {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 600;
  color: rgba(248, 250, 252, 0.9);
}

.lt-coach-dash__stat-muted {
  opacity: 0.7;
  font-weight: 600;
  font-size: 0.85em;
}

.lt-coach-dash__stat svg {
  color: var(--lt-brand, #0877bc);
}

.lt-coach-dash__setup-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.82rem;
  cursor: pointer;
  border: none;
  background: var(--lt-brand, #0877bc);
  color: #fff;
  flex-shrink: 0;
}

.lt-coach-dash__setup-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lt-coach-dash__chrono-btn {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
  color: #e2e8f0;
}

.lt-coach-dash__chrono-btn:hover,
.lt-coach-dash__chrono-btn--active {
  background: var(--lt-brand, #0877bc);
  color: #fff;
  border-color: var(--lt-brand, #0877bc);
}

.lt-coach-dash__tables-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.82rem;
  cursor: pointer;
  flex-shrink: 0;
  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #fff);
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 88%, #0f172a);
  color: #f8fafc;
}

.lt-coach-dash__tables-btn svg {
  color: #f8fafc;
}

.lt-coach-dash__tables-btn:hover {
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 75%, #fff);
}

.lt-coach-dash__tables-btn--inline {
  width: 100%;
  justify-content: center;
}

.lt-coach-dash__setup-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #fff);
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 88%, #0f172a);
  color: #f8fafc;
  cursor: pointer;
  flex-shrink: 0;
}

.lt-coach-dash__setup-icon-btn:hover {
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 75%, #fff);
}

.lt-coach-dash__classement-btn {
  background: rgba(251, 191, 36, 0.15);
  color: #fcd34d;
  border: 1px solid rgba(251, 191, 36, 0.35);
}

.lt-coach-dash__classement-btn:hover {
  background: rgba(251, 191, 36, 0.22);
}

.lt-coach-dash__feedback-btn {
  position: relative;
}

.lt-coach-dash__feedback-icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lt-coach-dash__error {
  margin: 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.4);
  color: #fecaca;
  font-size: 0.85rem;
  flex-shrink: 0;
}

.lt-coach-dash__kot-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

.lt-coach-dash__kot-stop {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border: none;
  border-radius: 6px;
  background: rgba(239, 68, 68, 0.2);
  color: #fca5a5;
  font-size: 0.65rem;
  font-weight: 700;
  cursor: pointer;
}

.lt-coach-dash__kot-submitting {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  background: rgba(56, 189, 248, 0.16);
  border: 1px solid rgba(56, 189, 248, 0.35);
  color: #7dd3fc;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  animation: lt-kot-submitting-pulse 1.4s ease-in-out infinite;
}

@keyframes lt-kot-submitting-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
}

.lt-coach-dash__kot-submit-error {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid rgba(239, 68, 68, 0.45);
  border-radius: 6px;
  background: rgba(239, 68, 68, 0.14);
  color: #fecaca;
  font-size: 0.65rem;
  font-weight: 700;
  cursor: pointer;
}

.lt-coach-dash__leaderboard-strip,
.lt-coach-dash__seq-strip {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}

.lt-coach-dash__lb-title {
  font-weight: 700;
  font-size: 0.82rem;
  color: rgba(248, 250, 252, 0.9);
}

.lt-coach-dash__lb-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.lt-coach-dash__lb-chip,
.lt-coach-dash__seq-chip {
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 0.72rem;
  color: rgba(248, 250, 252, 0.85);
}

.lt-coach-dash__seq-chip--active {
  background: var(--lt-brand, #0877bc);
  border-color: var(--lt-brand, #0877bc);
  color: #fff;
  font-weight: 700;
}

.lt-demo-review {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  backdrop-filter: blur(12px);
  flex-shrink: 0;
}

.lt-demo-review__label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.62);
}

.lt-demo-review__chips {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 2px;
  -webkit-overflow-scrolling: touch;
}

.lt-demo-review__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 7px 12px;
  border-radius: 999px;
  border: 1px solid rgba(34, 197, 94, 0.35);
  background: rgba(34, 197, 94, 0.12);
  color: #ecfdf5;
  font-size: 0.78rem;
  font-weight: 650;
  cursor: pointer;
  transition: background 0.18s cubic-bezier(0.22, 1, 0.36, 1),
    border-color 0.18s ease, transform 0.18s ease;
}

.lt-demo-review__chip:hover {
  background: rgba(34, 197, 94, 0.22);
  border-color: rgba(34, 197, 94, 0.55);
}

.lt-demo-review__chip:focus-visible {
  outline: 2px solid #22c55e;
  outline-offset: 2px;
}

@media (max-width: 640px) {
  .lt-coach-dash__toolbar {
    flex-wrap: wrap;
  }

  .lt-coach-dash__toolbar-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .lt-coach-dash__toolbar-actions .lt-coach-dash__tables-btn,
  .lt-coach-dash__toolbar-actions .lt-coach-dash__setup-btn {
    flex: 1 1 auto;
    justify-content: center;
    min-width: 0;
  }
}

.lt-coach-dash__recording-modes {
  /* Fixed above the sticky coach bar (Finalize / Start round) so FABs stay tappable */
  position: fixed;
  right: max(12px, env(safe-area-inset-right, 0px));
  bottom: calc(var(--lt-coach-bar-reserve, 68px) + 32px);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  z-index: 1250;
}

.lt-page--landscape .lt-coach-dash__recording-modes {
  bottom: max(12px, env(safe-area-inset-bottom, 0px));
  right: calc(212px + env(safe-area-inset-right, 0px));
}

.lt-coach-dash__recording-btn {
  background: var(--lt-brand, #0877BC);
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  transition: all 0.2s;
  flex-shrink: 0;
}

.lt-coach-dash__recording-btn.active {
  background: #d32f2f;
  animation: pulse 1.5s infinite;
}

.lt-coach-dash__recording-btn--leaderboard {
  background: rgba(251, 191, 36, 0.92);
  color: #422006;
}

.lt-coach-dash__recording-btn--leaderboard:hover {
  background: #fcd34d;
}

@media (max-width: 420px) {
  .lt-coach-dash__recording-modes {
    bottom: calc(var(--lt-coach-bar-reserve, 92px) + 12px);
  }
}

@keyframes pulse {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.7); }
  70% { transform: scale(1.1); box-shadow: 0 0 0 10px rgba(211, 47, 47, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(211, 47, 47, 0); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingCoachDashboard.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB;;;;GAIC;EACD;+EAC6E;AAC/E;;AAEA;;EAEE,oEAAoE;EACpE,uEAAuE;AACzE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yEAAyE;EACzE,+EAA+E;EAC/E,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kFAAkF;EAClF,+EAA+E;EAC/E,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,kFAAkF;EAClF,+EAA+E;EAC/E,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;iDAC+C;AACjD;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,cAAc;IACd,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA;EACE,oFAAoF;EACpF,eAAe;EACf,iDAAiD;EACjD,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wCAAwC;EACxC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,KAAK,mBAAmB,EAAE,0CAA0C,EAAE;EACtE,MAAM,qBAAqB,EAAE,2CAA2C,EAAE;EAC1E,OAAO,mBAAmB,EAAE,wCAAwC,EAAE;AACxE","sourcesContent":["/* Coach dashboard — dark theme aligned with .lt-kot__table-card */\n.lt-coach-dash {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  gap: 8px;\n  padding: 4px 0 8px;\n  color: #f8fafc;\n  overflow: hidden;\n}\n\n.lt-coach-dash__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 12px;\n  background: rgba(15, 23, 42, 0.92);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  backdrop-filter: blur(8px);\n}\n\n.lt-coach-dash__toolbar-actions {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.lt-coach-dash__action-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px;\n  border-radius: 10px;\n  background: color-mix(\n    in srgb,\n    var(--lt-brand-secondary, #46528b) 14%,\n    rgba(15, 23, 42, 0.5)\n  );\n  border: 1px solid\n    color-mix(in srgb, var(--lt-brand, #0877bc) 24%, rgba(255, 255, 255, 0.08));\n}\n\n.light-mode .lt-coach-dash__action-group,\nhtml[data-theme=\"light\"] .lt-coach-dash__action-group {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 6%, #f8fafc);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);\n}\n\n.lt-coach-dash__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n.lt-coach-dash__stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: rgba(248, 250, 252, 0.9);\n}\n\n.lt-coach-dash__stat-muted {\n  opacity: 0.7;\n  font-weight: 600;\n  font-size: 0.85em;\n}\n\n.lt-coach-dash__stat svg {\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-coach-dash__setup-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 0.82rem;\n  cursor: pointer;\n  border: none;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.lt-coach-dash__setup-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.lt-coach-dash__chrono-btn {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n  color: #e2e8f0;\n}\n\n.lt-coach-dash__chrono-btn:hover,\n.lt-coach-dash__chrono-btn--active {\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  border-color: var(--lt-brand, #0877bc);\n}\n\n.lt-coach-dash__tables-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 0.82rem;\n  cursor: pointer;\n  flex-shrink: 0;\n  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #fff);\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 88%, #0f172a);\n  color: #f8fafc;\n}\n\n.lt-coach-dash__tables-btn svg {\n  color: #f8fafc;\n}\n\n.lt-coach-dash__tables-btn:hover {\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 75%, #fff);\n}\n\n.lt-coach-dash__tables-btn--inline {\n  width: 100%;\n  justify-content: center;\n}\n\n.lt-coach-dash__setup-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 8px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand-secondary, #46528b) 55%, #fff);\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 88%, #0f172a);\n  color: #f8fafc;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.lt-coach-dash__setup-icon-btn:hover {\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 75%, #fff);\n}\n\n.lt-coach-dash__classement-btn {\n  background: rgba(251, 191, 36, 0.15);\n  color: #fcd34d;\n  border: 1px solid rgba(251, 191, 36, 0.35);\n}\n\n.lt-coach-dash__classement-btn:hover {\n  background: rgba(251, 191, 36, 0.22);\n}\n\n.lt-coach-dash__feedback-btn {\n  position: relative;\n}\n\n.lt-coach-dash__feedback-icon-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-coach-dash__error {\n  margin: 0;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  color: #fecaca;\n  font-size: 0.85rem;\n  flex-shrink: 0;\n}\n\n.lt-coach-dash__kot-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.lt-coach-dash__kot-stop {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 6px;\n  border: none;\n  border-radius: 6px;\n  background: rgba(239, 68, 68, 0.2);\n  color: #fca5a5;\n  font-size: 0.65rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.lt-coach-dash__kot-submitting {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: rgba(56, 189, 248, 0.16);\n  border: 1px solid rgba(56, 189, 248, 0.35);\n  color: #7dd3fc;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  animation: lt-kot-submitting-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes lt-kot-submitting-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.65;\n  }\n}\n\n.lt-coach-dash__kot-submit-error {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid rgba(239, 68, 68, 0.45);\n  border-radius: 6px;\n  background: rgba(239, 68, 68, 0.14);\n  color: #fecaca;\n  font-size: 0.65rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.lt-coach-dash__leaderboard-strip,\n.lt-coach-dash__seq-strip {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  flex-shrink: 0;\n}\n\n.lt-coach-dash__lb-title {\n  font-weight: 700;\n  font-size: 0.82rem;\n  color: rgba(248, 250, 252, 0.9);\n}\n\n.lt-coach-dash__lb-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.lt-coach-dash__lb-chip,\n.lt-coach-dash__seq-chip {\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  font-size: 0.72rem;\n  color: rgba(248, 250, 252, 0.85);\n}\n\n.lt-coach-dash__seq-chip--active {\n  background: var(--lt-brand, #0877bc);\n  border-color: var(--lt-brand, #0877bc);\n  color: #fff;\n  font-weight: 700;\n}\n\n.lt-demo-review {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 12px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 12px;\n  backdrop-filter: blur(12px);\n  flex-shrink: 0;\n}\n\n.lt-demo-review__label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.62);\n}\n\n.lt-demo-review__chips {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 8px;\n  overflow-x: auto;\n  padding-bottom: 2px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.lt-demo-review__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  padding: 7px 12px;\n  border-radius: 999px;\n  border: 1px solid rgba(34, 197, 94, 0.35);\n  background: rgba(34, 197, 94, 0.12);\n  color: #ecfdf5;\n  font-size: 0.78rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: background 0.18s cubic-bezier(0.22, 1, 0.36, 1),\n    border-color 0.18s ease, transform 0.18s ease;\n}\n\n.lt-demo-review__chip:hover {\n  background: rgba(34, 197, 94, 0.22);\n  border-color: rgba(34, 197, 94, 0.55);\n}\n\n.lt-demo-review__chip:focus-visible {\n  outline: 2px solid #22c55e;\n  outline-offset: 2px;\n}\n\n@media (max-width: 640px) {\n  .lt-coach-dash__toolbar {\n    flex-wrap: wrap;\n  }\n\n  .lt-coach-dash__toolbar-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .lt-coach-dash__toolbar-actions .lt-coach-dash__tables-btn,\n  .lt-coach-dash__toolbar-actions .lt-coach-dash__setup-btn {\n    flex: 1 1 auto;\n    justify-content: center;\n    min-width: 0;\n  }\n}\n\n.lt-coach-dash__recording-modes {\n  /* Fixed above the sticky coach bar (Finalize / Start round) so FABs stay tappable */\n  position: fixed;\n  right: max(12px, env(safe-area-inset-right, 0px));\n  bottom: calc(var(--lt-coach-bar-reserve, 68px) + 32px);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  z-index: 1250;\n}\n\n.lt-page--landscape .lt-coach-dash__recording-modes {\n  bottom: max(12px, env(safe-area-inset-bottom, 0px));\n  right: calc(212px + env(safe-area-inset-right, 0px));\n}\n\n.lt-coach-dash__recording-btn {\n  background: var(--lt-brand, #0877BC);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.lt-coach-dash__recording-btn.active {\n  background: #d32f2f;\n  animation: pulse 1.5s infinite;\n}\n\n.lt-coach-dash__recording-btn--leaderboard {\n  background: rgba(251, 191, 36, 0.92);\n  color: #422006;\n}\n\n.lt-coach-dash__recording-btn--leaderboard:hover {\n  background: #fcd34d;\n}\n\n@media (max-width: 420px) {\n  .lt-coach-dash__recording-modes {\n    bottom: calc(var(--lt-coach-bar-reserve, 92px) + 12px);\n  }\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.7); }\n  70% { transform: scale(1.1); box-shadow: 0 0 0 10px rgba(211, 47, 47, 0); }\n  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(211, 47, 47, 0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
